import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m10.146 22.683-1.65 3.8 5.05-.9a9 9 0 1 0-3.4-2.9Zm4.85-9.79a1.608 1.608 0 0 0-1.608 1.607v1a6.108 6.108 0 0 0 6.108 6.108h1a1.608 1.608 0 0 0 0-3.216h-1a1.608 1.608 0 0 0-1.362.754 3.892 3.892 0 0 1-2.284-2.284 1.613 1.613 0 0 0 .754-1.362v-1a1.608 1.608 0 0 0-1.608-1.608Zm0 2c.125 0 .245.037.346.107a.608.608 0 0 1-.691 0c.1-.07.22-.108.345-.108Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgWhatsapp;